import Score from "./components/Score";
import Controls from "./components/Controls";

function App() {
  return (
    <div style={{ marginTop: "20px" }}>
      <Score />
      <Controls />
    </div>
  );
}

export default App;
